import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { SortDirection } from '../../core/helpers/sort-direction';
import { FilterOperators } from '../../core/helpers/filter-operators';
import { SortDescriptor } from '../../core/helpers/sort-descriptor';
import { PropertyFilter } from '../../core/helpers/property-filter';
import { ControlBase } from '../../base/helpers/control-base';
import { InsightsComponent } from '../../insights/insights/insights.component';
import { Entity, EntityType, EntityState, SaveResult, QueryResult, EntityKey } from 'breeze-client';
import { keyCodes } from '../../base/helpers/key-codes';
import { BreezeService } from '../../core/breeze.service';
import { DataRights } from '../../core/helpers/data-rights.enum';
import { RoutesService } from '../../routes.service';
var ListBase = /** @class */ (function (_super) {
    tslib_1.__extends(ListBase, _super);
    /**
     * Constructs a ListComponent.
     * @param configurationsService Service to get the configuration of this component.
     * @param breezeService Service to load and save entity data.
     * @param dialogService Service for displaying dialogs.
     * @param alertsService Service for publish alerts.
     * @param translateService The translation service.
     */
    function ListBase(userService, breezeService, dialogService, alertsService, translateService, router, overlayService, localStorageService, eventsService, actionService) {
        var _this = _super.call(this, alertsService) || this;
        _this.userService = userService;
        _this.breezeService = breezeService;
        _this.dialogService = dialogService;
        _this.alertsService = alertsService;
        _this.translateService = translateService;
        _this.router = router;
        _this.localStorageService = localStorageService;
        _this.actionService = actionService;
        /** Event triggered when a entity from the list is selected. */
        _this.selectionChanged = new EventEmitter();
        /** Event triggered when a new entity is created. */
        _this.entityCreated = new EventEmitter();
        /** Event triggered when a new data set is retrieved from the backend api. */
        _this.onRefresh = new EventEmitter();
        /** Event triggered when modifications are committed. */
        _this.itemSaved = new EventEmitter();
        /**
         * Gets, Sets the search value to use as filter.
         */
        _this.searchValue = '';
        /**
         * Gets, sets the last search value to enable smart refreshing.
         * @private
         */
        _this.lastSearchValue = '';
        _this.timeoutId = 0;
        /** Collection of selected entities */
        _this._selected = [];
        /** Sorting rules used to create the EntityQuery. */
        _this.sorting = [];
        /** The source name of the requested entities. */
        _this.sourceName = undefined;
        /** The list of unsortable field editors */
        _this.unSortableEditors = ['color', 'repeat', 'marketplace-demand', 'marketplace-service', 'profile-picture', 'spendtime-context'];
        /** The sortable field names based on the config */
        _this.sortableFieldNames = [];
        /** The current sued fields for sorting */
        _this.sortedFields = [];
        /** Aditional options to generate the requested EntityQuery */
        _this.queryOptions = { skip: 0 };
        /** Collection of retrieved and shown entities */
        _this.items = [];
        /**
         * Indicates whether data is loaded
         */
        _this.isDataLoaded = false;
        /**
         * List of displayed supported search fields.
         * @protected
         * @type {string[]}
         */
        _this.searchFields = [];
        /** List of dynamic query parameters. */
        _this.dynamicParameters = [];
        /** Indicates whether the select all option is selected. */
        _this.multiSelectChecked = false;
        /** Compontent is in refresh mode */
        _this.isRefreshing = true;
        _this.subscriptionPool.add(overlayService.onClosed.subscribe(function (param) {
            if (param === 'refreshList') {
                _this.refresh();
            }
        }));
        _this.subscriptionPool.add(eventsService.register('action-completed').subscribe(function () {
            _this.refresh();
        }));
        return _this;
    }
    Object.defineProperty(ListBase.prototype, "selected", {
        get: function () { return this._selected; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListBase.prototype, "dataSet", {
        get: function () {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListBase.prototype, "current", {
        /**
         * Gets the current selected entity.
         * @type {Entity}
         */
        get: function () {
            return this._current;
        },
        /**
         * Sets the current selected entity.
         */
        set: function (value) {
            if (this._current === value) {
                return;
            }
            this.changeCurrent(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListBase.prototype, "isCreating", {
        /** Returns a value indicating whether a new entity is pending. */
        get: function () {
            return this.current && this.current.entityAspect.entityState === EntityState.Added;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListBase.prototype, "canSearch", {
        /**
         * Gets whether the list contains any searchable fields.
         * @readonly
         * @type {boolean} A value indicating whether the list can be filtered.
         */
        get: function () {
            return this.searchFields.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListBase.prototype, "canActions", {
        /**
         * Gets whether there are actions available
         * @readonly
         * @type {boolean}
         */
        get: function () {
            return (this.configuration.actions && this.configuration.actions.length > 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListBase.prototype, "userResourceKey", {
        /** Gets the resource key of the current user. */
        get: function () {
            return this.userService.user.Resource_Oid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListBase.prototype, "disableListActions", {
        /**
         * Gets the disable state of the list action buttons (clone and delete).
         * @readonly
         * @type {boolean}
         */
        get: function () {
            if (!this.hasSelectedItems()) {
                return true;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListBase.prototype, "currentKey", {
        /**
         * Gets the key of the current entity or null when no entity is selected.
         * @readonly
         * @type {string}
         */
        get: function () {
            if (!this.current) {
                return null;
            }
            var multiKey = this.current.entityAspect.getKey(false);
            var key = '';
            multiKey.values.forEach(function (value) { return key += '_' + value; });
            return key.substring(1);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Is called to change the current selected entity.
     * Override this method to extend the logic.
     * @protected
     * @param {Entity} value The new current entity or null
     */
    ListBase.prototype.changeCurrent = function (value) {
        this._current = value;
    };
    /**
     * This sets up the filter used for the list. This is overridable in components inheriting from the ListBase
     *
     * @protected
     */
    ListBase.prototype.setupSearchFilter = function () {
        var _this = this;
        // Clear filter.
        this.filter = null;
        this.lastSearchValue = this.searchValue;
        if (this.searchValue) {
            // Create filter
            var searchItems = this.lastSearchValue.trim().split(' ');
            searchItems.forEach(function (text) {
                var item = text.trim();
                if (item !== '') {
                    _this.searchFields.forEach(function (field) {
                        var dummy = new PropertyFilter(_this, field, FilterOperators.Contains, item, FilterOperators.Or);
                    });
                }
            });
        }
    };
    /**
     * Is called after user has changed the searchValue
     * @param {Event} evt Triggered by keyup.
     */
    ListBase.prototype.searchWith = function (event) {
        var _this = this;
        event.cancelBubble = true;
        if (this.lastSearchValue === this.searchValue) {
            return;
        }
        clearTimeout(this.timeoutId);
        this.isRefreshing = true;
        this.timeoutId = window.setTimeout(function () {
            _this.setupSearchFilter();
            _this.refresh();
        }, 500);
    };
    /**
     * Creates a new entity.
     */
    ListBase.prototype.create = function () {
        if (this.current && this.current.entityAspect.entityState.isAdded()) {
            return;
        }
        var item = this.entityType.createEntity();
        this.breezeService.addEntity(item); // First addEntity then setDefaultValues
        this.breezeService.setDefaultValues(this.userService.user, item);
        this.current = item;
        this.afterCreated(item);
    };
    /**
     * Checks whether an entity is the current entity.
     * @param item The entity to check.
     * @returns True when the item is the current entity.
     */
    ListBase.prototype.isActive = function (item) {
        return item ? this.current === item : false;
    };
    /**
     * Determines whether or not an item should be displayed as BOLD
     *
     * @param {Entity} item The item that should be checked
     * @returns {boolean} True when it should be displayed as bold, otherwise false
     *
     */
    ListBase.prototype.isBold = function (item) {
        return false;
    };
    /**
     * Determines whether or not an item should be selectable
     *
     * @param {Entity} item The item that should be checked
     * @returns {boolean} True when the item should be selectable, otherwise false
     *
     */
    ListBase.prototype.isSelectable = function (item) {
        return true;
    };
    /**
     * Checks if an entity is the current entity.
     * @returns True when a item is the current entity
     */
    ListBase.prototype.hasActive = function () {
        return (this.current != null);
    };
    /**
     * Checks whether an entity is part of the selected collection
     * @param item The entity to check.
     * @returns True when the item is part of the selected collection.
     */
    ListBase.prototype.isSelected = function (item) {
        return this.selected.indexOf(item) > -1;
    };
    /**
     * Indicates whether the select all options is selected.
     * @returns True when the select all options is selected.
     */
    ListBase.prototype.isMultiSelectChecked = function () {
        return this.multiSelectChecked;
    };
    /**
     * Makes an entity the entity with focus.
     * @param item The entity to select.
     */
    ListBase.prototype.select = function (item) {
        if (!item || this.current === item) {
            return;
        }
        this.current = item;
        this.selectionChanged.emit(item);
    };
    /**
     * Listener for global key down events
     * @param $event The event
     */
    ListBase.prototype.keyDown = function (event) {
        /**
         * PAS OP: 'document:keydown.out-zone' leek het te doen samen met this.changeDetector.detectChanges()
         * Maar als de pagina niet meer mee scrolt met up of down wordt de detail view niet meer geupdate.
         * Als we hier 'document:keydown.out-zone' willen moeten we dus de detail view zelf actief
         * op de 1 of andere manier ook een this.changeDetector.detectChanges() geven.
         */
        if (document.activeElement === document.body && (event.keyCode === keyCodes['up'] || event.keyCode === keyCodes['down'])) {
            this.onKeyUpOrKeyDown(event.keyCode);
        }
    };
    /**
     * Release the focus of an entity.
     * @param item The entity to deselect.
     */
    ListBase.prototype.deselect = function (item) {
        if (item || item === this.current) {
            this.current = null;
            return item;
        }
        return null;
    };
    /**
     * Toggles the select all option or enforces a state on the option.
     * @param selectAll The state to anforce on the option.
     */
    ListBase.prototype.toggleMultiSelect = function (selectAll) {
        var _this = this;
        // Toggle multi select checked
        this.multiSelectChecked = (selectAll !== undefined) ? selectAll : !this.multiSelectChecked;
        // Start with an empty selection
        // this.selected.splice(0, this.selected.length);
        this.selected.length = 0;
        if (this.multiSelectChecked) {
            // Add all checklist to selection
            this.items.forEach(function (item) {
                if (_this.isSelectable(item)) {
                    _this.selected.push(item);
                }
            });
        }
    };
    /**
     * Removes an entity from the list.
     * Is used when deleted by the detail form.
     * @param {string} id The identity of the entity.
     */
    ListBase.prototype.removeItem = function (id) {
        if (!id) {
            return;
        }
        var values = [id];
        if (id.indexOf('K_-') !== 0) {
            values = id.split('_');
        }
        var key = new EntityKey(this.entityType, values);
        var index = this.items.findIndex(function (item) { return item.entityAspect.getKey().equals(key); });
        if (index === -1) {
            return;
        }
        this.items.splice(index, 1);
        index = this.selected.findIndex(function (item) { return item.entityAspect.getKey().equals(key); });
        if (index === -1) {
            return;
        }
        this.selected.splice(index, 1);
    };
    /**
     * Appends or removes a entity from the selected collection.
     * @param item The entity to append or remove from the selected collection.
     */
    ListBase.prototype.toggleSingleSelect = function (item) {
        if (!this.isSelectable(item)) {
            return;
        }
        // Find position of item in selection
        var positionInSelected = this.selected.indexOf(item);
        if (positionInSelected > -1) {
            // Remove item from selection
            this.selected.splice(positionInSelected, 1);
        }
        else {
            // Add item to selection
            this.selected.push(item);
        }
        // test if none or all checklist are in selection (for correct representation of multi select icon)
        if (this.selected.length === 0) {
            this.multiSelectChecked = false;
        }
        else {
            if (this.selected.length === this.items.length) {
                this.multiSelectChecked = true;
            }
        }
    };
    /**
     * Checks whether the selected collection has entities.
     * @returns True when the collection has entities.
     */
    ListBase.prototype.hasSelectedItems = function () {
        return (this.selected.length > 0);
    };
    /**
     * Gives the number of entities in the selected collection.
     * @returns The number of entities in the selected collection.
     */
    ListBase.prototype.numberOfSelectedItems = function () {
        return this.selected.length;
    };
    /**
     * Indicates whether the data set has entities.
     * @returns True when the data set has entities.
     */
    ListBase.prototype.hasItems = function () {
        return this.items.length > 0;
    };
    ListBase.prototype.lookup = function () {
        this.refresh();
    };
    /**
     * Deletes a entity.
     * @param item The entity to delete.
     * @param index The index of the entity within the data collection.
     */
    ListBase.prototype.deleting = function (item, index) {
        this.deleteItem(item, index);
        this.save(undefined);
    };
    /**
     * Commits modifications in the entity model.
     * @param event The HTML event argument that triggered this method.
     */
    ListBase.prototype.save = function (event) {
        if (event) {
            event.target.classList.add('sym-working');
        }
        var self = this;
        this.subscriptionPool.add(this.breezeService.saveChanges(function (error) {
            // Remove sym-working to show that action is finished
            if (event) {
                event.target.classList.remove('sym-working');
            }
            // Give correct alert based on whether an error is given or not
            if (error) {
                self.alertsService.createAlert('warning', 'APP.LISTS.ITEMS_UNSUCCESSFULLY_SAVED');
            }
            else {
                self.alertsService.createAlert('success', 'APP.LISTS.ITEMS_SUCCESSFULLY_SAVED');
            }
        }).subscribe(function (value) {
            self.current = null;
            self.refresh();
            self.itemSaved.emit(value);
        }));
    };
    /**
     * Deletes all the entities in the selected collection.
     * @param event The HTML event that invoked this method.
     */
    ListBase.prototype.deleteSelected = function (event) {
        var _this = this;
        if (this.disableListActions) {
            return;
        }
        // Check if action is not called again before previous run is finished
        if (event && event.target.classList.contains('sym-working')) {
            this.alertsService.createAlert('warning', 'APP.LISTS.WAIT_UNTIL_DELETING_IS_FINISHED');
        }
        // Add sym-working to show that application is working
        if (event) {
            event.target.classList.add('sym-working');
        }
        // Run through selected checklist and give them a delete flag
        this.selected.forEach(function (item) {
            _this.breezeService.setDeleted(item);
            _this.items.find(function (test, i) {
                if (test === item) {
                    _this.items.splice(i, 1);
                    if (_this.current === item) {
                        _this.current = null;
                        _this.selectionChanged.emit(null); // Force to close detail view.
                    }
                    return true;
                }
                return false;
            });
        });
        // Save the entities
        this.breezeService.saveChanges(function (error) {
            // Remove sym-working to show that action is finished
            if (event) {
                event.target.classList.remove('sym-working');
            }
            // Give correct alert based on whether an error is given or not
            if (error) {
                _this.alertsService.createAlert('warning', 'APP.LISTS.ITEMS_UNSUCCESSFULLY_DELETED', error);
                // Restore not deleted.
                _this.refresh();
            }
            else {
                _this.alertsService.createAlert('success', 'APP.LISTS.ITEMS_SUCCESSFULLY_DELETED');
                // Do a refresh to hide deleted checklist
                _this.refresh();
            }
        });
    };
    /**
     * Returns whether the component is read-only according to the configuration.
     * @returns {boolean} A value indicating whether the component is read-only.
     */
    ListBase.prototype.isReadOnly = function () {
        if (Array.isArray(this.configuration.rights)) {
            var rights = this.configuration.rights;
            return rights.indexOf('Create') < 0 && rights.indexOf('Update') < 0;
        }
        else {
            // tslint:disable-next-line:no-bitwise
            return !(this.configuration.rights & DataRights.Create + DataRights.Update);
        }
    };
    /**
     * Method to retrieve the requested entities from the backend api.
     * @returns An Observable object that retrieves the requested entities.
     */
    ListBase.prototype.refresh = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.configuration) {
                            return [2 /*return*/, null];
                        }
                        BreezeService.setDynamicParams(this.queryOptions, this.dynamicParameters, this);
                        // Set in refresh mode
                        this.isRefreshing = true;
                        // Remove selected
                        this.toggleMultiSelect(false);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.breezeService.getDataSet(this, this.items)];
                    case 2:
                        result = _a.sent();
                        this.onRefresh.emit(result);
                        this.isDataLoaded = true;
                        this.isRefreshing = false;
                        this.restoreSelectedDetail();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.isDataLoaded = true;
                        this.isRefreshing = false; // Fix for #1554
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * Is called after a new entity is created.
     * The method triggers the entityCreated event.
     * Override this method to extend logic after creation.
     * @protected
     * @param {Entity} item The entity that is created.
     */
    ListBase.prototype.afterCreated = function (item) {
        this.entityCreated.emit(item);
    };
    /**
     * Restores the selected detail item when url is a detail route.
     * @protected
     */
    ListBase.prototype.restoreSelectedDetail = function () {
        var keyValue = RoutesService.getDetailId(this.router.routerState);
        if (keyValue != null) {
            var key_1 = new EntityKey(this.entityType, keyValue.split('_'));
            var item = this.items.find(function (i) { return i.entityAspect.getKey(false).equals(key_1); });
            if (item) {
                this.current = item;
            }
        }
    };
    /**
     * Is called when key arrow up or down is used.
     * The main list selects the next item, up or down, in response.
     * @protected
     * @param {number} keyCode Key code of the key event.
     */
    ListBase.prototype.onKeyUpOrKeyDown = function (keyCode) {
        var _this = this;
        // Only proceed if there is a active item
        if (this.hasActive()) {
            var position_1 = -1;
            // Find the current item position in items
            this.items.forEach(function (item, index) {
                if (item === _this.current) {
                    position_1 = index;
                }
            });
            // Stop if current item is not found in items
            if (position_1 === -1) {
                return;
            }
            // Based on key code go up or down
            if (keyCode === keyCodes['up']) {
                // Stop if current is at the top of the items
                if (position_1 === 0) {
                    return;
                }
                // Set previous position
                position_1 = position_1 - 1;
            }
            else if (keyCode === keyCodes['down']) {
                // Stop if current is at the bottom of the items
                if (position_1 === this.items.length - 1) {
                    return;
                }
                // Set next position
                position_1 = position_1 + 1;
            }
            // Change active item
            this.select(this.items[position_1]);
        }
        else {
            // No active, set first one active if exist
            this.select(this.items[0]);
        }
    };
    /**
     * Method to initialize the data set for the first time.
     */
    ListBase.prototype.initItemSet = function () {
        var _this = this;
        var entityConfig = this.configuration.data;
        if (entityConfig.listSize == null) {
            throw new Error('List size in the configuration is mandatory');
        }
        this.sourceName = entityConfig.dataSource;
        this.queryOptions.parameters = Object.assign({}, entityConfig.parameters);
        this.queryOptions.expand = entityConfig.expand;
        this.queryOptions.take = entityConfig.listSize;
        BreezeService.getDynamicParams(this.queryOptions, this.dynamicParameters);
        BreezeService.setDynamicParams(this.queryOptions, this.dynamicParameters, this);
        this.breezeService.registerSource(entityConfig.entity, this);
        var fields = this.configuration.data.fields;
        fields.forEach(function (field) {
            ControlBase.setFieldDefaults(field, _this.entityType);
            if (_this.isSortable(field)) {
                _this.sortableFieldNames.push(field.name);
            }
            // Zijn er nog meer velden waar we niet op kunnen zoeken?
            // Hier eigenlijk niet op editor beslissen maar op entity property type.
            switch (field.editor) {
                case 'string':
                case 'text':
                case 'email':
                case 'url':
                case 'phone':
                    _this.searchFields.push(field.name);
                    break;
                case 'entity':
                    field.format.fields.forEach(function (fld) {
                        _this.searchFields.push(field.name + '.' + fld);
                    });
                    break;
            }
        });
        this.setColumnClasses(fields);
        if (this.items.length > 0 && this.items[0].entityType !== this.entityType) {
            // Dit geeft problemen als je met de lijst een nieuwe entity maakt die komt dan niet in je lijst.
            console.warn('Mismatch between type of source (' +
                this.items[0].entityType.name +
                ') and entity type (' +
                this.entityType.name +
                ') in configuration ' +
                this.configuration.key);
        }
    };
    /**
     * Toggles the sort direction of a specific field.
     * @param field The field of the changing sort direction.
     */
    ListBase.prototype.toggleSort = function (field) {
        if (!this.isSortable(field)) {
            return;
        }
        // First find if the field is already used for sorting
        var foundSortedField = this.sortedFields.find(function (sortedField) { return sortedField['name'] === field.name; });
        // Yes, field is already sorted
        if (foundSortedField) {
            if (foundSortedField.direction === SortDirection.Ascending) {
                // Sort direction is ascending, toggle means make it descending
                foundSortedField.direction = SortDirection.Descending;
            }
            else {
                // Sort direction is descending, toggle means remove from sort
                this.sortedFields = this.sortedFields.filter(function (sortedField) {
                    return (sortedField.name !== foundSortedField.name);
                });
            }
        }
        else {
            // Add new sorting
            this.sortedFields.push({
                name: field.name,
                property: this.extractSortProperty(field),
                direction: SortDirection.Ascending
            });
        }
        var propertyName = this.configuration.key.split('/').join('-') + '-sort';
        this.localStorageService.updateProperty('local', propertyName, this.sortedFields);
        this.updateSort();
        this.refresh();
    };
    ListBase.prototype.updateSort = function () {
        var _this = this;
        if (!this.configuration.key) {
            return;
        }
        // Read the stored ordening
        var propertyName = this.configuration.key.split('/').join('-') + '-sort';
        this.sortedFields = this.localStorageService.readProperty('local', propertyName, []);
        // Clean up fields if they are not part of configuration anymore
        this.sortedFields = this.sortedFields.filter(function (sortedField) {
            return (_this.sortableFieldNames.indexOf(sortedField.name) !== -1);
        });
        // Empty the sorting array
        this.sorting.length = 0;
        this.sortedFields.forEach(function (sortedField, index) {
            _this.sorting.push(new SortDescriptor(sortedField.name, sortedField.property, sortedField.direction, index));
        });
    };
    /**
     * Override this method to implement logic to store the control state set by the user.
     * @param configKey Reference to the appropiate configuration. Use this reference to save and find the stored state of the control.
     */
    ListBase.prototype.restoreState = function (configKey) {
        this.isDataLoaded = false;
        this.initItemSet();
        this.updateSort();
        this.refresh();
    };
    /**
     * Check if a field editor is sortable
     */
    ListBase.prototype.isSortable = function (field) {
        if (this.unSortableEditors.indexOf(field.editor) !== -1) {
            return false;
        }
        if (field.editor === 'entity') {
            return true;
        }
        if (this.serverSideSortablePath(this.entityType, field.name.split('.'))) {
            return true;
        }
        return false;
    };
    /**
     * Finds the SortDirection of a given entity property.
     *
     * @param property The property name to look for.
     *
     * @returns The found SortDirection or SortDirection.None.
     */
    ListBase.prototype.sortDirectionOf = function (field) {
        var direction = SortDirection.None;
        // Find the position
        this.sortedFields.forEach(function (sortedField) {
            if (sortedField.name === field.name) {
                direction = sortedField.direction;
            }
        });
        return direction;
    };
    /**
     * Finds the order of the sort rule of a specific entity property.
     *
     * @param property The property name to look for.
     *
     * @returns The found order or zero.
     */
    ListBase.prototype.sortOrderOf = function (field) {
        var position = 0;
        // Find the position
        this.sortedFields.forEach(function (sortedField, index) {
            if (sortedField.name === field.name) {
                position = index + 1;
            }
        });
        return position;
    };
    /**
     * Method to create a new entity.
     * @param initialValues The initial property values of the entity.
     * @param index The insert location of the new created entity.
     * @returns The new created entity.
     */
    ListBase.prototype.createItem = function (initialValues, index) {
        var item = this.entityType.createEntity(initialValues);
        item = this.breezeService.addEntity(item);
        if (index) {
            // Useful for inline editing.
            this.items.splice(index, 0, item);
            return item;
        }
        return item;
    };
    /**
     * Deletes a entity.
     * @param item The entity to delete.
     * @param index The location of the entity within the shown list.
     * @returns The deleted entity.
     */
    ListBase.prototype.deleteItem = function (item, index) {
        var _this = this;
        this.breezeService.setDeleted(item);
        this.breezeService.saveChanges(function (error) {
            if (error) {
                _this.alertsService.createAlert('warning', 'APP.LISTS.ITEMS_UNSUCCESSFULLY_DELETED');
            }
            else {
                _this.dataSet.refresh(); // Reason: inform pagination of a changing dataset #1664
                _this.alertsService.createAlert('success', 'APP.LISTS.ITEMS_SUCCESSFULLY_DELETED');
            }
        });
        return item;
    };
    /**
     * Checks whether or not the action is allowed.
     * @param {ActionConfiguration} action The action to check.
     * @returns {boolean} True when allowed
     * @memberOf ListBase
     */
    ListBase.prototype.isAllowed = function (action) {
        return this.userService.isActionAllowed(action);
    };
    /**
     * Returns the action's icon
     * @param {ActionConfiguration} action The action
     * @returns {string} An icon class name
     * @memberOf ListBase
     */
    ListBase.prototype.getIcon = function (action) {
        return this.actionService.getIcon(action);
    };
    /**
     * Returns the action's label key
     * @param {ActionConfiguration} action The action
     * @returns {string} A translation label
     * @memberOf ListBase
     */
    ListBase.prototype.getLabelKey = function (action) {
        return this.actionService.getLabelKey(action);
    };
    /**
     * Event when action is clicked.
     * @param {*} event Click event
     * @param {ActionConfiguration} actionConfiguration Action of click event.
     * @memberOf ListBase
     */
    ListBase.prototype.actionSelected = function (event, actionConfiguration) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var input, message, error_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Is action allowed
                        if (actionConfiguration.isSelectionNeeded !== false && this.disableListActions) {
                            return [2 /*return*/];
                        }
                        // Check if action is not called again before previous run is finished
                        if (event && event.target.classList.contains('sym-working')) {
                            return [2 /*return*/, this.alertsService.createAlert('warning', 'APP.LISTS.WAIT_UNTIL_ACTION_IS_FINISHED')];
                        }
                        // Add sym-working to show that application is working
                        if (event) {
                            event.target.classList.add('sym-working');
                        }
                        input = {
                            actionConfiguration: actionConfiguration,
                            listBase: this,
                            breezeService: this.breezeService
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.actionService.doAction(input)];
                    case 2:
                        message = _a.sent();
                        this.toggleMultiSelect(false);
                        // Skip empty messages. An empty message may be the result of the user canceling the action.
                        if (message) {
                            this.alertsService.createAlert('success', message);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _a.sent();
                        if (error_2) {
                            if (!error_2.labelKey) {
                                return [2 /*return*/, this.alertsService.createAlert('danger', 'APP.SOCIAL.ACTION_NOT_FOUND', new Error('No labelKey is found'))];
                            }
                            if (!error_2.message) {
                                return [2 /*return*/, this.alertsService.createAlert('danger', error_2.labelKey)];
                            }
                            return [2 /*return*/, this.alertsService.createAlert('danger', error_2.labelKey, error_2.message)];
                        }
                        return [2 /*return*/, this.alertsService.createAlert('danger', 'APP.SOCIAL.ACTION_NOT_FOUND', new Error('Received Error is undefined'))];
                    case 4:
                        if (event) {
                            event.target.classList.remove('sym-working');
                        }
                        return [7 /*endfinally*/];
                    case 5:
                        this.refresh();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sets the widths of the columns and calculates the last column
     * @param fields The set of fields.
     */
    ListBase.prototype.setColumnClasses = function (fields) {
        var sumSize = 0;
        var maxSize = (this.canDelete || this.canCreate) ? 23 : 24; // Give the checkbox in the rows some space!
        // Run through the fields
        fields.forEach(function (field, index) {
            // If no size is given set the default
            if (!field['size']) {
                switch (field.editor) {
                    case 'color': {
                        field['size'] = 1;
                        break;
                    }
                    case 'duration': {
                        field['size'] = 2;
                        break;
                    }
                    default: {
                        field['size'] = 3;
                        break;
                    }
                }
            }
            // Add to sum
            sumSize = sumSize + field['size'];
            // Give last column the rest of the space except if total
            // size of the columns is larger than maxSize.
            if (index === fields.length - 1 && sumSize < maxSize) {
                field['size'] = field['size'] + (maxSize - sumSize);
            }
        });
    };
    /**
     * Extract the description of the sort property,
     * this to support sorting for multi field composed list columns
     * @private
     * @param {FieldConfiguration} field The configuration of the column.
     * @returns {string} The sort description of the property
     */
    ListBase.prototype.extractSortProperty = function (field) {
        if (field.editor === 'entity') {
            var fields_1 = '';
            field.format.fields.forEach(function (fld) {
                fields_1 += ',' + field.name + '.' + fld;
            });
            return fields_1.substring(1);
        }
        return field.name;
    };
    /**
     * Checks if path is server-side sortable.
     * @private
     * @param {EntityType} entityType The entity type of the path.
     * @param {string[]} path Array of property names
     * @returns {boolean} True when path is sortable server side.
     */
    ListBase.prototype.serverSideSortablePath = function (entityType, path) {
        if (entityType == null) {
            // entityType Nog niet geladen. Bezig met herstel opgeslagen sortering.
            return true;
        }
        if (path == null || path.length === 0) {
            // Empty path is not sortable.
            return false;
        }
        if (path.length === 1) {
            var property = entityType.getProperty(path[0], false);
            if (property == null) {
                // Property does not exist.
                return false;
            }
            if (property['isUnmapped']) {
                // Property exist only on client-side.
                return false;
            }
            if (property.isNavigationProperty) {
                // Navigation property is not sortable.
                return false;
            }
            // Is Sortable Server-side property.
            return true;
        }
        var navProperty = entityType.getNavigationProperty(path[0]);
        if (navProperty == null) {
            // Navigation property does not exist.
            return false;
        }
        if (navProperty['isUnmapped']) {
            // Property exist only on client-side.
            return false;
        }
        // Check next step in path.
        path.splice(0, 1);
        return this.serverSideSortablePath(navProperty.entityType, path);
    };
    /**
     * Used to improve the performances of the list by introducing
     * an unique identifier per row.
     *
     * @param {number} index The index number
     * @param {Entity} item The item for given row
     * @returns {String} The unique identifier
     */
    ListBase.prototype.trackByItem = function (index, item) {
        if (!item || !item.entityAspect) {
            return index.toString();
        }
        var key = '';
        item.entityAspect.getKey().values.forEach(function (value) {
            key += '_' + value;
        });
        if (key.length <= 1) {
            return index.toString();
        }
        return key.substring(1);
    };
    return ListBase;
}(ControlBase));
export { ListBase };
